var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow-large-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2241 2.87593C13.4584 3.11025 13.4584 3.49014 13.2241 3.72446L7.24833 9.7002L13.2241 15.6759C13.4584 15.9102 13.4584 16.2901 13.2241 16.5245C12.9898 16.7588 12.6099 16.7588 12.3755 16.5245L5.97554 10.1245C5.74123 9.89015 5.74123 9.51025 5.97554 9.27593L12.3755 2.87593C12.6099 2.64162 12.9898 2.64162 13.2241 2.87593Z",
    fill: "#1D2023"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowIcon);
export default __webpack_public_path__ + "static/media/left-arrow-icon.7104de08c83a36130fadebb986bfe3bd.svg";
export { ForwardRef as ReactComponent };